module.exports = __webpack_public_path__ + "img/apoio-gekko.b7373863.png";